
import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService, CalendarService, FieldService } from '../../../services';
import { ModalComponent } from '../../modal/modal.component';
import { Condition, User } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscActionPlanComponent } from '../usc-action-plan/usc-action-plan.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sn-usc-previous-action-plans',
    templateUrl: './usc-previous-action-plans.component.html',
    styleUrls: ['./usc-previous-action-plans.component.css']
})
export class UscPreviousActionPlansComponent implements OnInit {

    public view: string;
    public active_user: User;
    public action_plans: Array<any> = [];
    public filtered_action_plans: Array<any> = [];
    public columnFields: Array<any> = [];
    public visibleColumnFields: Array<any> = [];
    public pageFilterFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    public action_plans_loaded: boolean = false;
    public metadata_loaded: boolean = false;
    public is_group_label_enabled: boolean = false;
    public column_groups: any = [];
    public action_plan_fields: any[];
    portalReadySub: Subscription;
    // search
    public searchText: string;
    // paging 
    public curPage: number = 1;
    public pageSize: number = 15;
    public pageCount: number = 1;
    public itemCount: number = 0;
    public orderBy: string = 'cs_case_number';
    public asc: boolean;
    protected conditionResults: Array<Condition> = [];
    public header_style: any = { 'font-size': '12px', 'font-weight': 'bold', 'color': 'white', 'text-align': 'center' }

    constructor(
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public fieldService: FieldService,
    ) {
        this.active_user = this.authService.getActive();
    }

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_previous_action_plans;
        // order of operations
        // 1. load metadata to get column_fields and view_conditions
        // 2. load action plans 
        // 3. evaluate view_conditions for each action plan
        // 4. determine viewable columns by column_field's visible/sn_column_visible
        // 5. generate filter data for each filter columns
        this.loadTableViewMetaData();
    }

    loadTableViewMetaData() {
        if (!this.metadata_loaded) {
            this.metadataService.getTableViewMetaData(this.uscStoreService.view_p2w_previous_action_plans, {}, true).subscribe(result => {
                this.metadata_loaded = true;
                //console.log(result.meta_data.column_fields);
                this.columnFields = result.meta_data.column_fields;
                this.viewConditions = result.meta_data.view_conditions;
                // load view items here after meta data is downloaded
                this.reloadItems();
            });
        }

        this.metadataService.getFormViewMetaData(this.uscStoreService.view_p2w_previous_action_plans, {}).subscribe(
            result => {
                this.action_plan_fields = result.meta_data.view_fields;
            },
            err => { console.log(err) }
        )
    }

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType: string = null) {
        var params: any = {}
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (executeScriptType) params.est = executeScriptType;
        params.obd = this.asc ? "asc" : "desc";
        return params;
    }

    getExecuteScriptType(bSearchData: boolean = true, bTotalCount: boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }

    reloadItems(searchText: string = null) {
        this.column_groups = [];
        // reset state variable before reloading action plans
        this.action_plans_loaded = false;
        // this.uscStoreService.getPreviousActionPlans().subscribe(items => {
        {
            if (!this.metadata_loaded) this.loadTableViewMetaData();
            // this.action_plans = items;
            this.action_plans = this.uscStoreService.getAllPreviousActionPlans(this.active_user);
            this.filtered_action_plans = this.action_plans;
            this.action_plans_loaded = true;

            this.action_plans.forEach(ap => {
                if (this.viewConditions) {
                    var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                    ap.viewConditions = this.conditionService.evaluateItemValues(conditions, null, ap);
                }
            });

            this.action_plans.sort(function (a, b) {
                var a_sort_path = a.avp_team + a.dos_team + a.asm_team + a.store_team + a.ur_associate_name;
                var b_sort_path = b.avp_team + b.dos_team + b.asm_team + b.store_team + b.ur_associate_name;
                return a_sort_path < b_sort_path ? -1 : 1;
            })

            this.columnFields.forEach(cf => {
                if (cf.visible) {
                    var bVisible = true;
                    if (cf.sn_column_visible && this.action_plans.length > 0) {
                        var condResult = this.conditionService.getCondition(this.action_plans[0].viewConditions, cf.sn_column_visible);
                        bVisible = condResult ? condResult.result : true;
                    }
                    if (bVisible) this.visibleColumnFields.push(cf);
                }
                var enable_filtering = cf.enable_filtering;
                if (cf.sn_enable_filtering && this.action_plans.length > 0) {
                    var condResult = this.conditionService.getCondition(this.action_plans[0].viewConditions, cf.sn_enable_filtering);
                    enable_filtering = condResult ? condResult.result : true;
                }
                if (cf.is_page_filter && enable_filtering) this.pageFilterFields.push(cf);
            })
            //this.pageCount = 1;

            // from visible columns, pre-construct grouping <td>
            if (this.visibleColumnFields.find(f => f.group_label != null && f.group_label.length > 0) != null) this.is_group_label_enabled = true;
            if (this.is_group_label_enabled) {
                this.column_groups = [];
                for (var i = 0; i < this.visibleColumnFields.length; i++) {
                    var curr_field = this.visibleColumnFields[i];
                    var curr_group_label = curr_field.group_label ? curr_field.group_label : '';
                    var g = this.column_groups.find(cg => cg.label == curr_group_label);
                    if (g == null) {
                        g = { label: curr_group_label, colspan: 1, class: curr_field.cell_class }
                        this.column_groups.push(g);
                    } else {
                        g.colspan++;
                    }
                }
            }

            this.generateFilterData();
            var bUpdateFilteredActionPlan = false;
            this.pageFilterFields.forEach(f => {
                if (!f.allow_all_as_filter_value && f.current_filtered_value == null) {
                    f.current_filtered_value = f.filter_data[0].value;
                    bUpdateFilteredActionPlan = true;
                }
            })

            if (bUpdateFilteredActionPlan) this.updateFilteredActionPlan();
        // })
        }
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.reloadItems(this.searchText);
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.reloadItems(this.searchText);
        }
    }

    onFieldBtnEvent(btnEvent) {
        console.log(btnEvent);
        switch (btnEvent.btn.event) {
            case "sn_open_modal_view": this.openModalView(btnEvent); break;
            case "sn_open_modal_component": this.openModalComponent(btnEvent); break;
        }
    }

    openModalView(btnEvent) {
        var data = [];
        var view = "";
        switch (btnEvent.btn.modal_view) {
            case "view_bfp_form_file_upload":
                data = btnEvent.item;
                view = btnEvent.btn.modal_view;
                break;
        }

        this.modalService.openContent(
            ModalComponent,
            { view: view, data: data },
            { backdrop: 'static', keyboard: false }
        ).result.then((result) => {
            this.sessionService.log(view + ' submitted');
        }, (reason) => {
            this.sessionService.log('Form Closed');
        })
    }

    openModalComponent(btnEvent) {
        switch (btnEvent.btn.modal_component) {
            case "sn-usc-attachment-lookup": this.showAttachments(btnEvent.item); break;
        }
    }
 
    showAttachments(item) {
        this.modalService.openContent(
            AttachmentLookupComponent,
            { view: this.view, data: item, related_type: "case", related_ID: item.view_ID, title: "Attachments - Claim #" + item.cs_case_number },
            { size: "lg", backdrop: 'static', keyboard: false }
        ).result.then((result) => {
            console.log(result);
        }, (reason) => {
            console.log('Attachment Closed');
        });
    }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.orderBy ? true : !this.asc;
        this.orderBy = event.field.key;
        this.setActiveSortColumn(event.field.key);
        this.reloadItems();
    }

    setActiveSortColumn(column_key: string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }

    getFieldFilterDisplay(action_plan, field): any {
        if (action_plan && field) {
            var field_display = this.getFieldValue(action_plan, field);
            switch (field.key) {
                case "cs_subject":
                    field_display = this.uscStoreService.convertPlanMonth(field_display);
                    break;
            }

            return field_display;
        }
        return null;
    }

    getFieldValue(action_plan, field): any {
        if (action_plan && field) {
            var field_value = action_plan[field.key];
            switch (field.key) {
                case 'cs_approver':
                    if (action_plan.cs_status != this.uscStoreService.action_plan_status_approved) field_value = "";
                    break;
                case 'cs_approval_requested_on':
                case 'cs_approval_received_on':
                    field_value = this.calendarService.getDateText(new Date(field_value), 'yyyy-MM-dd');
                    break;
                case "cs_p2w_postpaid":
                case "cs_p2w_other":
                case "cs_p2w_bir":
                case "cs_p2w_accessories_revenue":
                case "cs_p2w_other_revenue":
                case "cs_p2w_upgrades":
                case "cs_p2w_high_acc":
                case "cs_p2w_device_trade_ins":
                case "days_worked":
                    if (action_plan.ur_title == 'Store' || action_plan.ur_title == 'Assistant Manager') return "N/A";  // store action plan 
                    break;
            }

            return field_value;
        }
        return null;
    }

    onBtnClick(btn, action_plan, field) {
        //this.onFieldBtnEvent.emit({ btn: btn, item: this.item, field: this.field });
        switch (btn.event) {
            case "sn_open_action_plan": this.gotoActionPlan(btn, action_plan, field); break;
            case "sn_send_ap_reminder": this.sendActionPlanReminder(btn, action_plan, field); break;
        }
    }

    sendActionPlanReminder(btn, action_plan, field) {
        this.modalService.openContent(
            UscDialogComponent,
            { dlgType: this.uscStoreService.dialog_type_action_plan_reminder },
            { backdrop: 'static', keyboard: false }
        ).result.then(
            (result) => {
                var params = { ur_user_ID: action_plan.ur_user_ID };
                var action = this.uscStoreService.action_this_month_ap_reminder;
                if (this.view == this.uscStoreService.view_p2w_team_next_action_plans) action = this.uscStoreService.action_next_month_ap_reminder;
                this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, action_plan.view_ID, action, params).subscribe(
                    result => {
                        this.sessionService.log("action plan reminder sent");
                    }
                )
            },
            (reason) => { }
        );
    }

    gotoActionPlan(btn, action_plan, field, is_prev_action_plan:boolean = false) {
        this.uscStoreService.setActionPlan(action_plan);
        //     if (is_prev_action_plan) {
        // } else if (action_plan.ur_title == 'Store' || action_plan.ur_title == 'Assistant Manager') {
        //     if (action_plan.view_ID == null) {
        //         let dlg = this.showCustomPromptDlg({}, { msg: "Loading Action Plan" });
        //         this.apiService.getViewItem(this.uscStoreService.view_p2w_action_plan, 0).subscribe(
        //             result => {
        //                 var new_action_plan = result.item;
        //                 if (this.view == this.uscStoreService.view_p2w_team_this_action_plans) {
        //                     new_action_plan.cs_subject = this.uscStoreService.getThisMonthActionPlanSubject();
        //                 } else if (this.view == this.uscStoreService.view_p2w_team_next_action_plans) {
        //                     new_action_plan.cs_subject = this.uscStoreService.getNextMonthActionPlanSubject();
        //                 }

        //                 new_action_plan.cs_user_ID = action_plan.ur_user_ID;
        //                 var form_fields = this.fieldService.getFormFields(this.action_plan_fields, new_action_plan);
        //                 this.apiService.saveViewItem(this.uscStoreService.view_p2w_action_plan, new_action_plan.view_ID, form_fields).subscribe(
        //                     ap => {
        //                         dlg.dismiss();
        //                         var item = this.uscStoreService.formFieldsToViewItem(ap);
        //                         this.uscStoreService.setActionPlan(item);
        //                     }
        //                 )
        //             },
        //             err => {
        //                 console.log("error");
        //             }
        //         )
        //     } else {
        //         this.uscStoreService.setActionPlan(action_plan);
        //     }
        // } else if (action_plan.cs_status != this.uscStoreService.action_plan_status_draft) {
        //     this.uscStoreService.setActionPlan(action_plan);
        // }
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    isValueVisible(action_plan, field) {
        // if (field && action_plan && action_plan.viewConditions) {
        //     var condResult = this.conditionService.getCondition(action_plan.viewConditions, field.sn_value_visible);
        //     return condResult ? condResult.result : true;
        // }
        return true;
    }

    isBtnVisible(btn, action_plan, field) {
        if (action_plan && action_plan.viewConditions) {
            var condResult = this.conditionService.getCondition(action_plan.viewConditions, btn.sn_visible);
            return condResult ? condResult.result : true;
        }
        return true;
    }

    isColumnVisible(column) {
        switch (column.key) {
            // case 'ur_firstname':
            // case 'ur_lastname':
            // case 'ur_team_name':
            //     return this.uscStoreService.isLeader();
            default:
                return column.visible;
        }
    }

    isImageIcon(btn) { return (btn.button_type == "IMG"); }
    isFontAwesomeIcon(btn) { return (btn.button_type != "IMG"); }

    // #region Data Filters
    generateFilterData() {
        this.columnFields.forEach(f => {
            if (f.enable_filtering || f.is_page_filter) f.filter_data = this.getDataFilter(f);
        })
    }

    getDataFilter(field) {
        var filter_list = !field.allow_all_as_filter_value ? [] : [{ label: 'All', value: '' }];
        if (this.action_plans_loaded && (field.enable_filtering || field.is_page_filter)) {
            if (field.filter_data_source == 'data') {
                // if allow_all_as_filter_value == false, extract data filter from all action_plans
                if (field.is_page_filter && !field.allow_all_as_filter_value) {
                    this.action_plans.forEach(ap => {
                        var field_value = this.getFieldValue(ap, field);
                        var filter = filter_list.find(f => f.value == field_value);
                        if (filter == null) {
                            var field_label = this.getFieldFilterDisplay(ap, field);
                            filter_list.push({ label: field_label, value: field_value });
                        }
                    })
                } else {
                    this.filtered_action_plans.forEach(ap => {
                        var field_value = this.getFieldValue(ap, field);
                        var filter = filter_list.find(f => f.value == field_value);
                        if (filter == null) {
                            var field_label = this.getFieldFilterDisplay(ap, field);
                            filter_list.push({ label: field_label, value: field_value });
                        }
                    })
                }
            }
            filter_list.sort(function (a, b) {
                var sort_order = -1; // default: ascending order
                if (field.is_page_filter && field.filter_value_sort_order == 'desc') sort_order = 1;
                return (a.value < b.value) ? sort_order : sort_order * -1;
            })
        }
        return filter_list;
    }

    showFilteredValue(field): boolean {
        return (field && field.current_filtered_value);
    }

   getFilteredValue(field) {
        if (field.key == 'cs_subject') return this.uscStoreService.convertPlanMonth(field.current_filtered_value);
        return field.current_filtered_value;
    }

    filter(field, f) {
        field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
        this.updateFilteredActionPlan();
    }

    updateFilteredActionPlan() {
        this.filtered_action_plans = [];
        this.action_plans.forEach(ap => {
            var bInclude = true;
            this.columnFields.forEach(f => {
                if ((f.enable_filtering || f.is_page_filter) && f.current_filtered_value) {
                    bInclude = bInclude && ap[f.key] == f.current_filtered_value;
                }
            })
            if (bInclude) this.filtered_action_plans.push(ap);
        })
        this.generateFilterData();
    }
    // #endregion

    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-previous-action-plans/usc-previous-action-plans.component.ts